<div
  style="background-image: url('assets/sign-up-bg.svg')"
  class="seller-signup h-screen overflow-y-auto bg-[#BBDEEB] bg-cover bg-no-repeat bg-center"
>
  <div class="container mx-auto flex justify-center px-17.5 pt-12 relative">
    <sham-i-sham-logo-Full class="px-2 absolute top-4 xl:start-17.5 start-12" />

    <div
      class="max-w-[717px] xl:w-[717px] py-8 px-40 pb-10.5 rounded bg-white-light space-y-4"
    >
      <h2 class="font-semibold text-[32px] leading-[36px] p-2.5 text-center mb-2">
        Confirm Email
      </h2>

      <section class="space-y-4 text-center">
        @if (loading()) {
          <div class="space-y-3">
            <p class="text-[#178EB4] font-semibold">Confirming your email...</p>

            <p class="text-sm text-[#6D6D6D]">
              Please wait while we verify your confirmation link.
            </p>
          </div>
        } @else if (success()) {
          <div class="space-y-3">
            <p class="text-[#178EB4] font-semibold">Email confirmed successfully</p>

            <p class="text-sm text-[#6D6D6D]">
              Your email has been confirmed. You can now login.
            </p>

            <a href="/signin" class="text-blue font-semibold"> Go to Login </a>
          </div>
        } @else {
          <div class="space-y-3">
            <p class="text-sm text-red-600">
              {{ error() || 'Invalid or expired confirmation link.' }}
            </p>

            <a href="/signin" class="text-blue font-semibold"> Back to Login </a>
          </div>
        }
      </section>
    </div>
  </div>

  <div class="page-footer-copy text-center text-[#6D6D6D] mt-5">
    All rights reserved © Shamsuperstore.com
  </div>
</div>
